module.exports = __webpack_public_path__ + "static/media/boat-img-18.d77b9957.jpg";